export default [
  {
    label: 'Due to start undergraduate higher education in autumn 2026',
    label2: 'Undergraduate Higher Education',
    value: 'Undergraduate Higher Education'
  },
  {
    label: 'Living in further education accommodation or halls of residence for the first time in autumn 2026',
    label2: 'Living in Further Education Accommodation',
    value: 'Living in Further Education Accommodation'
  },
  {
    label: 'None of the above',
    label2: 'None of the above',
    value: 'None of the above'
  }
];
